import { Button } from '@mui/material'
import { createLink } from '@tanstack/react-router'

/** Equivalent of mui's Button but with safe router props */
export const RouterButton = createLink(Button)
